import React from "react";

import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { LazyMotion, MotionConfig } from "motion/react";
import { createRoot } from "react-dom/client";

import { App } from "src/App";
import { AppToaster } from "src/AppToaster";
import { queryClient } from "src/queryClient";
import { isRunningInCypressRun } from "src/utils/testingUtils";
import "src/styles/index.css";

const loadFramerMotionFeatures = () =>
  import("./framer-motion-features").then((res) => res.framerMotionFeatures);

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <MotionConfig
        reducedMotion="user"
        skipAnimations={isRunningInCypressRun()}
      >
        <LazyMotion features={loadFramerMotionFeatures} strict>
          <App />
        </LazyMotion>
      </MotionConfig>
      <ReactQueryDevtools initialIsOpen={false} position="bottom" />
      <AppToaster />
    </QueryClientProvider>
  </React.StrictMode>,
);
